import { createConsumer } from '@rails/actioncable';

type ContextChangePayload = {
  type: 'CONTEXT_CHANGE';
  person: {
    sfdcId: string;
  };
};

type CallLoggedPayload = {
  type: 'CALL_LOGGED';
  actionId: string | null;
  person: {
    id: string | null;
    sfdcId: string | null;
  };
};

export type ExtensionDialerPayload = ContextChangePayload | CallLoggedPayload;

export default createConsumer(process.env.SERVER_BASE_WS_URL!);
